import Photo from '../../Photo'

export function renderFloorPlanSlide(plan, pack, dots, zoomed, onDotHovered) {
  return <div className="swiper-zoom-container h-full">
  <div className="h-full flex items-center justify-center swiper-zoom-target">
    <Photo zoomed={zoomed} dots={!pack.generated && dots} photo={plan} pack={pack} onDotHovered={onDotHovered} />
  </div>
</div>
}
